import ButtonGroup from '@/global/components/ButtonGroup'
import { Button } from '@/global/components/ui/button'
import { cn } from '@/lib/utils'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

/** Mesmas alturas dos campos (`inputVariants`): as setas ficam do tamanho do campo ao lado. */
const ALTURA = {
    small: 'h-12',
    medium: 'h-14',
} as const

interface IPropsBotoesNavegacao {
    onAnterior: () => void
    onProximo: () => void
    /** Título e rótulo acessível — ex.: "Funcionário anterior". */
    rotuloAnterior: string
    rotuloProximo: string
    isAnteriorDesabilitado?: boolean
    isProximoDesabilitado?: boolean
    size?: keyof typeof ALTURA
    className?: string
}

/**
 * Par de setas anterior/próximo que acompanha um campo de filtro (competência,
 * funcionário). Tamanho fixo, na altura do campo, para que todos os pares da
 * tela fiquem iguais.
 */
export function BotoesNavegacao({
    onAnterior,
    onProximo,
    rotuloAnterior,
    rotuloProximo,
    isAnteriorDesabilitado,
    isProximoDesabilitado,
    size = 'small',
    className,
}: IPropsBotoesNavegacao) {
    const classeBotao = cn(ALTURA[size], 'w-12 shrink-0 p-0')

    return (
        <ButtonGroup className={cn('shrink-0', className)}>
            <Button
                type="button"
                variant="outline"
                title={rotuloAnterior}
                aria-label={rotuloAnterior}
                disabled={isAnteriorDesabilitado}
                onClick={onAnterior}
                className={classeBotao}
            >
                <ChevronLeftIcon className="text-foreground" />
            </Button>
            <Button
                type="button"
                variant="outline"
                title={rotuloProximo}
                aria-label={rotuloProximo}
                disabled={isProximoDesabilitado}
                onClick={onProximo}
                className={classeBotao}
            >
                <ChevronRightIcon className="text-foreground" />
            </Button>
        </ButtonGroup>
    )
}
